export default {
  search:  `profile/search`,
  show: (profileID) => `/profile/search/show/${profileID}`,
  stats: `/profile/search/stats`,
};

// term = ${ btoa(term) }
